/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, type FormEvent } from "react";

import inputStyles from "../../../../../assets/styles/components/input.module.css";
import styles from "./Modal.module.css";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import ModalGeneric from "../../../../../components/ModalGeneric/ModalGeneric";
import Button from "../../../../../components/Button/Button";
import { patchCategoryProduct, postCategoryProduct } from "../../../../../services/products";
import { toast } from "react-toastify";

interface prop {
  onClick: () => void;
  uid?: string;
  title?: string;
}
const Modal = ({ onClick, uid, title }: prop) => {
  const queryClient = useQueryClient();
  const [value, setValue] = useState(title || "");

  const { mutate } = useMutation({
    mutationFn: async (data: string) => {
      if (!uid) {
        const res = await postCategoryProduct(data);
        return res;
      }
      const res = await patchCategoryProduct(uid, data);
      return res;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["getCategoriesProducts"] });

      toast.success("Categoria criada com sucesso");
      setValue("");
      onClick();
    },
    onError: (error: any) => {
      toast.error(error || error.message);
    },
  });

  const submit = (e: FormEvent) => {
    e.preventDefault();
    if (!value) return;

    mutate(value);
  };

  return (
    <ModalGeneric
      containerClass={styles.containerWrapCategoryProduct}
      modalGenericCustom={styles.wrapCategoryProduct}
      headerClass={styles.headerClass}
      onClick={onClick}
      title={"Nova categoria para produtos"}>
      <form className={styles.containerCategoryProduct} onSubmit={submit}>
        <label>
          Título
          <input
            type="text"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            className={inputStyles.input}
          />
        </label>
        <Button variant="contain">Salvar</Button>
      </form>
    </ModalGeneric>
  );
};

export default Modal;
